import { formatChatFileSize } from './chat-file-limits'

/** What one mail a person sends from the portal may carry: the figures both the composer and the server read. */
export type MailAttachmentLimits = {
    /** The most files one mail may carry, inclusive. */
    maxFiles: number
    /** The most bytes all of one mail's files may hold together, inclusive. */
    maxTotalBytes: number
}

/**
 * The one published contract for files on a sent mail: 10 files, 7 MB together, both inclusive. The sending provider
 * takes a whole message of 10 MB at most, and a file travels base64-encoded (4 bytes for every 3), so 7 MB of files is
 * what still fits with the message around them. The composer states these and the API refuses against them.
 */
export const MAIL_ATTACHMENT_LIMITS: MailAttachmentLimits = { maxFiles: 10, maxTotalBytes: 7 * 1024 * 1024 }

/** The limits as one phrase a person reads before attaching: `up to 10 files, 7 MB together`. */
export function mailAttachmentLimitsSentence(limits: MailAttachmentLimits = MAIL_ATTACHMENT_LIMITS): string {
    return `up to ${limits.maxFiles} files, ${formatChatFileSize(limits.maxTotalBytes)} together`
}
